<script lang="ts">
	import type { Order } from "../../../../core/schema/Order.js";
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import OrderProductCard from "./OrderProductCard.svelte";
	import VoucherProductCard from "./VoucherProductCard.svelte";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import voucherImage from "../../../../core/assets/voucher.jpg?w=150&webp&imagetools";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";

	export let order: Order;
	export let products: ProductForCustomer[];
	export let imageByProductId: Record<string, UploadedFile>;
	export let onRepeatOrder: () => Promise<void>;
	export let voucherValue: number | undefined;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;
</script>

<div class="flex w-full flex-wrap justify-center gap-4 text-center md:justify-start md:text-left">
	{#each order.products as orderProduct, index}
		{@const product = products.find(({ id }) => id === orderProduct.product.id)}
		{#if product}
			<OrderProductCard
				{imageByProductId}
				{product}
				{orderProduct}
				{onRepeatOrder}
				orderStatus={order.status}
				isAlone={order.products.length === 1 && !order.appliedVoucher && order.vouchers.length === 0}
				isLast={index === order.products.length - 1}
			/>
		{/if}
	{/each}
	{#if voucherValue}
		<div class="border-t-1 flex w-full flex-col justify-between border-gray-200 p-4 md:p-6">
			<div class="flex gap-2 md:gap-4">
				<StaticPicture
					image={voucherImage}
					height={88}
					width={88}
					alt="Voucher icon"
					imgClass="rounded-md min-w-[3.5rem] md:min-w-[5.5rem] md:w-[5.5rem] w-[3.5rem] md:h-[5.5rem] h-[3.5rem] object-contain"
				/>
				<div class="flex w-full items-baseline justify-between">
					<p class="md:text-md text-base font-semibold">Slevový poukaz</p>
					<p class="md:text-md mt-2 hidden text-end font-bold lg:inline">
						-{formatPrice(voucherValue, TENANT_LOCALE, false)}
					</p>
				</div>
			</div>
			<p class="mt-2 text-end font-bold lg:hidden">
				-{formatPrice(voucherValue, TENANT_LOCALE, false)}
			</p>
		</div>
	{/if}
	{#each order.vouchers as voucher}
		<VoucherProductCard {voucher} {order} />
	{/each}
</div>
